import { SITE_HG, COUNTRY } from '@/config';

const HOSTING_URL_BY_BRAND = {
  br: `${SITE_HG}/hospedagem-de-sites`,
  cl: `${SITE_HG}/web-hosting`,
  co: `${SITE_HG}/web-hosting`,
  mx: `${SITE_HG}/web-hosting`,
  ar: `${SITE_HG}/web-hosting`,
  pe: `${SITE_HG}/web-hosting`,
  bo: `${SITE_HG}/web-hosting`,
  cr: `${SITE_HG}/web-hosting`,
  do: `${SITE_HG}/web-hosting`,
  ec: `${SITE_HG}/web-hosting`,
  sv: `${SITE_HG}/web-hosting`,
  pa: `${SITE_HG}/web-hosting`,
  py: `${SITE_HG}/web-hosting`,
  uy: `${SITE_HG}/web-hosting`,
};

export const HOSTING_URL = HOSTING_URL_BY_BRAND[COUNTRY];
